import axios from "@/api/interceptor_xxl";

/**
 * 财务管理
 * @param params
 * @returns
 */

// 入账记录
export function getTiktokFundsRecord(params: any) {
  return axios.get("/agent/funds/mine-record", { params });
}

// 二代记录
export function getTiktokFundsAgent2(params: any) {
  return axios.get("/agent/funds/agent2-record", { params });
}

// 直客记录
export function getTiktokFundsClient(params: any) {
  return axios.get("/agent/funds/client-record", { params });
}

// 代理充值
export function postTiktokFundsAgent(data: any) {
  return axios.post("/agent/funds/agent-recharge", data);
}
